(() => {
  if (!document.body.classList.contains('template-index')) return;
  const rootUrl = window.Shopify?.routes?.root || '/';

  function syncCartBadges(cart) {
    const value = cart.item_count < 100 ? String(cart.item_count) : (window.cartStrings?.item_99 || '99+');
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = node.closest('.cart-text') ? `(${value})` : value;
    });
    document.querySelectorAll('.mishop-sticky-cart-count').forEach((node) => { node.textContent = value; });
    document.querySelectorAll('.header__icon--cart, .mishop-sticky-cart').forEach((node) => {
      node.setAttribute('aria-label', `Carrito: ${cart.item_count}`);
    });
    window.updateCartEmptyStateVisibility?.(cart.item_count);
  }

  async function refreshCart(result) {
    const response = await fetch(`${rootUrl}cart.js`, { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && result?.sections && typeof drawer.renderContents === 'function') {
      try { await drawer.renderContents({ ...result, item_count: cart.item_count }); }
      catch (error) { console.warn('[MISHOP home] Cart drawer refresh failed', error); }
    }
    syncCartBadges(cart);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mishop-home', cartData: cart });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function initBenefitsSliders() {
    document.querySelectorAll('.mishop-home-benefits__slider').forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const rail = slider.querySelector('[data-benefits-rail]');
      const previous = slider.querySelector('[data-benefits-prev]');
      const next = slider.querySelector('[data-benefits-next]');
      if (!rail || !previous || !next) return;
      const sync = () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max - 2;
      };
      previous.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' }));
      next.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  initBenefitsSliders();

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.mishop-promotion-card__form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    const id = Number(form.querySelector('[name="id"]')?.value);
    if (!id || button?.disabled) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Añadiendo…';
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-icon-bubble'];
      const response = await fetch(window.routes?.cart_add_url || `${rootUrl}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'No se pudo añadir el producto.');
      await refreshCart(result);
      button.textContent = 'Añadido';
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1500);
    } catch (error) {
      console.error('[MISHOP home] Add to cart failed', error);
      button.textContent = 'Reintentar';
      button.disabled = false;
    }
  });
})();
